import { Modal, Typography, WarningIcon2 } from '@orijinworks/frontend-commons';
import React from 'react';
import { DeleteModalStyles } from './DeleteModal.styles';

const DeleteModal = React.memo(({ title, description, open, onClose, onContinue, modalRef }) => {
    return (

        <Modal
            ref={modalRef}
            actionBtnText='Confirm'
            cancelBtnText='Cancel'
            onContinue={onContinue}
            onClose={onClose}
            Icon={<WarningIcon2 sx={{ color: 'white' }} />}
            modalType={{ type: 'confirmation', status: 'danger', size: 'medium' }}
            labelledBy={title}
            describedBy={description}
            styles={{
                mainWrapperStyles: { height: 'auto' },
            }}
            mainModalStyles={DeleteModalStyles}
            open={open}
        >
            <Typography variant="h6">{title}</Typography>
            <Typography 
            styles={{
                color: 'blue'
            }}
            variant="body1">{description}</Typography>
        </Modal>
    );
});

export default DeleteModal;